import _ from 'lodash';
import { createSelector } from 'reselect';

import { ContactTypeExternalProvider } from 'constants/contactTypes';
import { getDriveCoverageRows } from 'utils/contactTypes';
import { prepareStringForComparison } from 'utils/data';

const getContactTypesState = state => state.contactTypes;

const selectContactTypes = createSelector(getContactTypesState, ({ contactTypes }) => contactTypes);

const DEFAULT_FAMILIES = [];

const createBusyNamesSelector = (sourceSelector, mapName = _.identity) =>
  _.memoize(id =>
    createSelector(sourceSelector, contactTypes =>
      contactTypes.filter(contactType => contactType.id !== id).map(({ name }) => mapName(name)),
    ),
  );

export const selectBusyContactTypesRoles = createBusyNamesSelector(selectContactTypes);

export const selectContactTypesOptions = createSelector(selectContactTypes, contactTypes =>
  contactTypes.map(({ id, name }) => ({ name, value: id })),
);

export const selectEditorContactTypes = createSelector(
  getContactTypesState,
  ({ editorContactTypes }) => editorContactTypes,
);

export const selectDriveCodeFamilies = createSelector(
  getContactTypesState,
  ({ externalCodeFamilies }) =>
    externalCodeFamilies[ContactTypeExternalProvider.DATA_VERIFY_DRIVE] ?? DEFAULT_FAMILIES,
);

export const selectBusyEditorContactTypeNames = createBusyNamesSelector(
  selectEditorContactTypes,
  prepareStringForComparison,
);

export const selectDriveCoverageRows = createSelector(
  selectDriveCodeFamilies,
  selectEditorContactTypes,
  getDriveCoverageRows,
);
